
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.101961 0 0 0 0 0.666667 0 0 0 0 0.592157 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-1)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M9.004 11.755a.64.64 0 00.641-.622v-8.19l-.049-1.196.552.566 1.225 1.292a.597.597 0 00.438.191c.34 0 .592-.24.592-.566a.552.552 0 00-.186-.415L9.475.215C9.312.055 9.166 0 9.005 0c-.163 0-.31.056-.471.215l-2.743 2.6c-.121.12-.194.247-.194.415 0 .327.251.566.584.566a.601.601 0 00.446-.191L7.86 2.313l.552-.566-.057 1.196v8.19c0 .335.3.622.65.622zM13.653 18c1.695 0 2.547-.83 2.547-2.472v-7.96c0-1.642-.852-2.472-2.547-2.472h-2.264V6.38h2.24c.802 0 1.265.43 1.265 1.26v7.816c0 .83-.463 1.26-1.266 1.26H4.364c-.812 0-1.258-.43-1.258-1.26V7.64c0-.83.446-1.26 1.258-1.26H6.61V5.096H4.347c-1.695 0-2.547.83-2.547 2.472v7.96C1.8 17.17 2.652 18 4.347 18h9.306z","fill":"#888","fill-rule":"nonzero"}})])])
          )
        }
      }
    